<template>
  <div>
    <div class="marTML pf23-subTit">
      <div class="widM fntH4 bold padTS padBS" style="color:#fff;">참가자 정보</div>
    </div>
    <div class="widM padTSM">
      <ul class="osResNoticeList fntE colorGray" style="padding-left:.5em; text-indent:-.5em;">
        <li>- <em style="color:#e11e45">*</em> 표시는 필수 입력사항입니다.</li>
        <li>- 첨부파일은 JPG, PNG, PDF, HEIC, HEIF 형식으로 최대 10MB까지 등록하실 수 있습니다.</li>
      </ul>
    </div>

    <div class="pf23-inFo-wrap">
      <div class="widM clearfix" v-if="mainResponses"> 
        <template v-for="(mainAttendant, idx) in mainResponses" >
          <SurveyParticipant
            :key="`mainAttendant${idx}`"
            :seq="idx"
            :participant="mainAttendant"
          />
          <span
            :key="`mainAttendant_span${idx}`"
            class="disIb moOnly" style="padding:2.5px;"
          />
          <hr
            v-if="idx < mainResponses.length - 1"
            :key="`mainAttendant_hr${idx}`"
            class="moOnly"
            style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;"
          />
        </template>
      </div>

      <!-- 안전 확인 : PC 인 경우는 주/부 에 대해서 표시된다. Mo 인 경우는 부 or 배우자인경우만 표시된다. 신기한 Style -->
      <SurveyParticipantFloat 
        :infoAvailable="infoAvailable" 
        :title="`안전 확인`" 
        :description="`‘안전확인동의서’ 에 ‘해당사항 있음’으로 체크한 항목이 있습니까? (임산부, 장애, 지병 및 기타 질병)`"
        :sqCode="`Q119`"
        :tooltip="true"
        :tooltipMessage="`* 해당 사항이 있는 경우 반드시 상세 내용을 동의서 상에 작성하여 주시기 바랍니다.`"
        :isRequired="true"
      /> 

      <SurveyParticipantFloat 
        :infoAvailable="infoAvailable" 
        :title="`알러지 및 식단 확인`" 
        :description="`알러지 또는 유의해야할 식단이 있습니까? 있다면 어떤 것인지 적어주십시오.`"
        :sqCode="`Q120`"
        :tooltip="false"
        :isRequired="false"
      />

      <SurveyParticipantFloat 
        :infoAvailable="infoAvailable" 
        :title="`VISA 발급 여부 `" 
        :description="`ETA(전자여행허가)를 신청하셨습니까?`"
        :sqCode="`Q121`"
        :tooltip="false"
        :isRequired="true"
      />
       
    </div>

  </div>
</template>

<script>
import SurveyParticipant from './SurveyParticipant.vue'
import SurveyParticipantSafe from './SurveyParticipantSafe.vue'
import SurveyParticipantFloat from './SurveyParticipantFloat.vue'
import { SURVEY_SYDNEY, INFO_AVAILABLE, ATTENDING_LIST, MAIN_RESPONSES, FAMILY_RESPONSES, MEMBER_ATTENDANTS } from '@/store/actions/survey'
import { mapState, mapGetters } from 'vuex'
import { CommonMethodMixin } from '../mixins'
import { getMessage } from '@/utils/survey'

export default {
  name: 'SurveyParticipantInfo',
  mixins: [CommonMethodMixin],
  components: {
    SurveyParticipant,
    SurveyParticipantSafe,
    SurveyParticipantFloat,
  },
  computed: {
    ...mapState(SURVEY_SYDNEY, {
      responses: state => state.responses,
    }),
    ...mapGetters(SURVEY_SYDNEY, {
      infoAvailable: INFO_AVAILABLE,
      attendingList: ATTENDING_LIST,
      mainResponses: MAIN_RESPONSES,
      familyResponses: FAMILY_RESPONSES,
      memberAttendants: MEMBER_ATTENDANTS,
    }),
    existMemberAttendant () {
      // return this.memberAttendants.length > 0;
      return false
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sydney/components/SurveyParticipantInfo.vue